import services from './services';

export { datatable } from './datatable';

const navigation = {
  'navigation.links.home': 'Accueil',
  'navigation.links.users': 'Utilisateurs',
  'navigation.links.dashboard': 'Tableau de bord',
  'navigation.links.a_traiter': 'Bordereaux à traiter',
  'navigation.links.history_actions': 'Historique des actions',
  'navigation.links.timesheet': 'Relevés d’heures',
  'navigation.links.advance': 'Demandes d’acomptes',
  'navigation.links.advance_manage_request': 'Demandes à traiter',
  'navigation.links.advance_history': 'Historique',
  'navigation.links.advance_manage_unavailabilities':
    'Gestion des indisponibilités',
  'navigation.links.advance_manage_unavailabilities.edit':
    'Modifier une indisponibilité',
  'navigation.links.delegations': 'Gestion des délégations',
  'navigation.links.delegations.create': 'Création d’une délégation',
  'navigation.links.delegations.update': 'Modification d’une délégation',
  'navigation.links.imports': 'Imports RH',
  'navigation.links.import.show': "Détail d'un import",
  'navigation.links.import.create': "Importer des relevés d'heures",
  'navigation.links.monitoring': 'Suivi des imports',
  'navigation.links.referentials': 'Référentiels clients',
  'navigation.links.referential_details': 'Détail du référentiel',
  'navigation.links.admin_users': 'Gestion des périmètres',
  'navigation.links.admin_user_show': 'Profil utilisateur',
  'navigation.links.missing_agencies': 'Agences manquantes',
};

const pages = {
  'pages.home.title': 'Bordereaux à traiter',
  'pages.404.title': 'Oopsi! Erreur 404',
  'pages.unavailable.title': 'Oups, un problème est survenu',
  'pages.unavailable.message':
    'Nina n’arrive pas à récupérer vos informations pour le moment. Merci de réessayer dans 5 minutes.',
  'pages.unavailable.retry': 'Réessayer',
  'pages.no-access.title': 'Oups, vous n’avez pas accès à Nina',
  'pages.no-access.message':
    'Votre compte n’est rattaché à aucune agence autorisée. Rapprochez-vous de votre responsable ou du support pour obtenir un accès.',
  'pages.missing-agencies.title': 'Agences manquantes',
  'pages.history-actions.title': 'Historique des actions',
  'pages.history-action.title': 'Détail du relevé d’heures - Historique',
  'pages.delegations.title': 'Délégations',
  'pages.timesheet.title':
    "Relevé d'heures importé le {{- date, DD/MM/YYYY HH:mm}}",
  'pages.timesheet.subtitle': "Détails du relevé d'heures",
  'pages.timesheet.panelTitle': 'Informations du RH',
  'pages.timesheet.title.import-date':
    'Importé le {{- date, DD/MM/YYYY }} à {{- date, HH:mm }}',
  'pages.timesheet.agency': 'Agence',
  'pages.timesheet.contract': 'Contrat',
  'pages.timesheet.coef': 'Coef.',
  'pages.timesheet.code': 'Code <b>{{- code }}</b>',
  'pages.timesheet.candidateMatricule': '({{ matricule }})',
  'pages.timesheet.anaelQualification':
    'Qualification anael <b>{{- anaelQualification }}</b>',
  'pages.timesheet.anaelCode': 'Code Anaël <b>{{- anaelCode }}</b>',
  'pages.timesheet.siteCode': 'Code chantier <b>{{- siteCode }}</b>',
  'pages.timesheet.contractSite': 'Code chantier : {{- siteCode }}',
  'pages.timesheet.client': 'Client',
  'pages.timesheet.week': 'Semaine <b>{{ week }}</b>',
  'pages.timesheet.pending': 'Contrat en cours',
  'pages.timesheet.cancelled': 'Contrat annulé',
  'pages.timesheet.closed': 'Contrat fermé',
  'pages.contract.card.closed': 'Fermé',
  'pages.timesheet.availableContracts':
    'Contrats correspondant à ce RH ({{ count }})',
  'pages.timesheet.closedContract': 'Contrat fermé',
  'pages.timesheet.contractSource': 'Informations fournies par le contrat',
  'pages.timesheet.importSource': "Informations fournies par l'import du RH",
  'pages.timesheet.contractNumberWithDate':
    '<b>{{contract}}</b> (du {{- startDate, DD/MM/YYYY }} au {{- endDate, DD/MM/YYYY }})',
  'pages.timesheet.attachedContract': 'Contrat rattaché',
  'pages.timesheet.contract.is.closed':
    'Le contrat {{ contractCode }} est fermé',
  'pages.timesheet.contract.is.cancelled':
    'Le contrat {{ contractCode }} est annulé',
  'pages.timesheet.detachContractWarning':
    'En cliquant sur détacher le contrat, il ne sera plus associé au RH. Êtes-vous sûr de vouloir détacher le contrat ?',
  'pages.timesheet.attachContractWarning':
    'Le contrat sélectionné remplacera le contrat actuel. Êtes-vous sûr de vouloir continuer ?',
  'pages.timesheet.manyAttachedContracts': 'Contrats rattachés ({{ count }})',
  'pages.timesheet.manyContractsAvailable': 'Plusieurs contrats correspondent',
  'pages.timesheet.noChosenContract': 'Aucun contrat trouvé',
  'pages.timesheet.pleaseSearchToFindContract':
    'Veuillez faire une recherche afin de trouver un contrat',
  'pages.timesheet.dataFromContract': 'Informations fournies par le contrat',
  'pages.timesheet.dataFromImport': "Informations fournies par l'import du RH",
  'pages.timesheet.noAttachedContract': "Aucun contrat n'est rattaché à ce RH",
  'pages.timesheet.contract_data': 'Données du contrat',
  'pages.timesheet.timesheet_data': 'Montant Total facturé',
  'pages.timesheet.anael_code': 'code anael',
  'pages.timesheet.construction_site_code': 'code chantier',
  'pages.timesheet.to': 'au',
  'pages.timesheet.candidate': 'Intérimaire',
  'pages.timesheet.candidatesName': 'Nom du candidat',
  'pages.timesheet.candidate_short': 'Intérim.',
  'pages.timesheet.cdii': 'CDII',
  'pages.timesheet.cdii.tooltip': 'CDI Intérimaire',
  'pages.timesheet.qualification': 'Qualification',
  'pages.timesheet.qualification_long': 'qualification anael',
  'pages.timesheet.contract_number': 'Numéro de contrat',
  'pages.timesheet.cancelledContract': 'Le contrat est annulé',
  'pages.timesheet.anaelIntegrationImpossible':
    "Il n'est pas possible de faire l'intégration vers Anaël",
  'pages.timesheet.weekDuration':
    'Durée hebdomadaire <b>{{ weeklyDuration }}h</b>',
  'pages.timesheet.client_comment': 'Commentaires client',
  'pages.timesheet.client_timesheet':
    '1/2 Relevés d’heures : matching infos client et Anaël',
  'pages.timesheet.infoBox.suggestion': 'Proposition de rubrique Anaël',
  'pages.timesheet.infoBox.noMatching': 'Pas de correspondance',
  'pages.timesheet.infoBox.title':
    'Relevé d’heures : matching infos client et Anaël',
  'pages.timesheet.no.comment': 'Pas de commentaire client',
  'pages.timesheet.commentaryBox.title': 'Commentaire client',
  'pages.timesheet.no.memo': 'Pas de memo RH',
  'pages.timesheet.memoBox.title': 'Memo RH',
  'pages.timesheet.no.documents': 'Pas de justificatifs',
  'pages.timesheet.documentsBox.title': 'Télécharger les justificatifs',
  'pages.timesheet.incidentLDBox.title': 'Incident longue durée',
  'pages.timesheet.incidentLDBox.message':
    'Des heures ont été saisies sur la période d’un incident de longue durée.',
  'pages.timesheet.infoBox.suggestion.tooltip':
    'Enregistré au bout de 3 saisies manuelles',
  'pages.timesheet.anael_timesheet':
    'Données à transmettre à Anaël - semaine {{week}}',
  'pages.timesheet.anael_timesheet.summary.title': 'Heures travaillées',
  'pages.timesheet.anael_timesheet.financial.title': 'Financier',
  'pages.timesheet.anael_timesheet.financial.suggested':
    'Nina vous propose ces rubriques en provenance du contrat',
  'pages.timesheet.anael_timesheet.financial.add_button': 'Ajouter une ligne',
  'pages.timesheet.client.switch': 'Afficher les données du Client',
  'pages.timesheet.total_billed': 'Total Facturé',
  'pages.timesheet.total_paid': 'Total Payé',
  'pages.timesheet.total_billed_client': 'Client',
  'pages.timesheet.total_billed_anael': 'Anaël',
  'pages.timesheet.timesheet_data.tooltip_client':
    'Le montant "Total Facturé" provient du relevé d’heures saisi par le client',
  'pages.timesheet.status.modified_by_client': 'Modifié par le client',
  'pages.timesheet.status.pending': 'A traiter',
  'pages.timesheet.status.pending_review': 'A vérifier',
  'pages.timesheet.status.label': 'Statut du RH',
  'pages.timesheet.timesheet_data.tooltip_client_no_infos':
    'Ce RH ne nous permet pas d’afficher les données client',
  'pages.timesheet.timesheet_data.tooltip_anael':
    'Le montant "Total Facturé" correspond aux données à transmettre à Anael',
  'pages.timesheet.noContract': 'Pas de contrat',
  'pages.timesheet.contractNumber': 'Contrat {{ contract }}',
  'pages.timesheet.clientAndCandidateData':
    'Entre {{ candidateLastName }} {{ candidateFirstName }} et {{ clientName }}',
  'pages.timesheet.chooseContract': 'Choisir un contrat',
  'pages.timesheet.selectedContract': 'Vous avez sélectionné le contrat ',
  'pages.timesheet.continueProcessing':
    'pour continuer le traitement des informations',
  'pages.timesheet.selectedOption': 'Vous avez sélectionné l’option ',
  'pages.timesheet.processOffTool':
    'nous vous recommandons de traiter ce relevé d’heures directement dans Anaël',
  'pages.timesheet.selectContractCode':
    '{{ contractCode }} - du {{- startDate, DD/MM/YYYY }} au {{- endDate, DD/MM/YYYY}}',
  'pages.timesheet.roundCategory.title':
    'Nina vous propose d’arrondir le montant envoyé à Anael',
  'pages.timesheet.roundCategory.message':
    'le montant total passera de {{ totalBilledAnael }} à {{ totalBilledClient }}',
  'pages.timesheet.roundCategory.btn': 'Arrondir',
  'pages.timesheet.zeroTotalBilledAlert.title':
    "{{ number }} relevés d'heures avec un montant à 0€",
  'pages.timesheet.count_invalid_timesheets':
    '{{ count }} RH sélectionné est à vérifier manuellement',
  'pages.timesheet.alert_invalid_timesheets':
    '{{ count }} RH sélectionné est "à vérifier" : il ne sera pas intégré et doit être vérifié manuellement',
  'pages.timesheet.zeroTotalBilledAlert.message':
    "Vous pouvez traiter tous ces relevés d'heures hors outil, en un instant.",
  'pages.timesheet.zeroTotalBilledAlert.btn': 'Traiter hors outil',
  'pages.timesheet.hoursAfterContractEnd.title':
    'Heures saisies après la fin du contrat',
  'pages.timesheet.hoursAfterContractEnd.message':
    "Des heures ont été saisies par le client après la date de fin de contrat, souplesse comprise. Vous pouvez traiter ce relevé d'heure hors outil.",
  'pages.timesheet.holiday': 'Jour ferié',
  'pages.timesheet.day_hour': 'Heures de jour',
  'pages.timesheet.night_hour': 'Heures de nuit',
  'pages.timesheet.holiday.warning': 'Cette semaine comporte un jour ferié.',
  'pages.timesheet.showClientData': 'Afficher les données client',
  'pages.timesheet.manyLogicCode': 'Renseigner un code logique par rubrique',
  'pages.timesheet.accordion.title':
    'Nina vous propose ces rubriques en provenance du contrat ({{ count }})',
  'pages.timesheet.details.noFinancial.error':
    'Pour pouvoir intégrer ce RH dans Anaël, veuillez renseigner un financier.',
  'pages.timesheet.accordion.details.noFinancial.title': 'Plus de rubrique',
  'pages.timesheet.accordion.details.noFinancial.description':
    'Vous avez intégré toutes les rubriques à votre RH',
  'pages.timesheet.table.noFinancial.title': "Vous n'avez pas de financier",
  'pages.timesheet.table.noFinancial.description':
    'Pour intégrer dans Anaël le RH, veuillez ajouter une rubrique ou une ligne',
  'pages.advance-requests-list.title':
    'Demandes d’acomptes / Demandes à traiter',
  'pages.advance-requests-history.title': 'Demandes d’acomptes / Historique',
  'pages.advance-periods-list.title':
    'Demandes d’acomptes / Gestion des indisponibilités du service',
  'pages.advance-periods-edit.title':
    'Demandes d’acomptes / Modification d’une indisponibilité du service',
  'pages.advance.service': 'du service',
  'pages.advance.switch.all_scopes.managementCenter':
    'Toutes les demandes de mon centre de gestion',
  'pages.advance.switch.all_scopes.superAdmin': 'Toutes les demandes',
  'pages.advance.pagination.results': 'résultats',
  'pages.advance.pagination.results_per_page': 'résultats par page',
  'pages.advance.manage.refresh.phrase': 'Mettre à jour les centres de gestion',
  'pages.advance.manage.refresh.success': 'Centres de gestion mis à jour',
  'pages.advance.manage.refresh.failed':
    'Erreur dans la mise à jour des centres de gestion',
  'pages.advance.manage.paragraph_first':
    'Le service de demande d’acompte en ligne accessible depuis l’Espace Personnel peut devenir indisponible selon les périodes renseignées ici.',
  'pages.advance.manage.paragraph_second.list.title':
    'Tous les ans, il vous faudra renseigner manuellement :',
  'pages.advance.manage.paragraph_second.list.items.first':
    'les indisponibilités <bold>dues à la gestion des acomptes</bold>',
  'pages.advance.manage.paragraph_second.list.items.first.items.first':
    '<bold>Métropole</bold> (de 00h00 à 14h00) : tous les lundis et jeudis matins hors semaines de paie et hors jours fériés',
  'pages.advance.manage.paragraph_second.list.items.first.items.second':
    '<bold>Antilles - Guyane</bold> (de 12h00 à 23h59) : tous les mercredis et vendredis hors semaines de paie et hors jours fériés',
  'pages.advance.manage.paragraph_second.list.items.second':
    'les indisponibilités <bold>dues à la gestion des paies</bold>',
  'pages.advance.manage.paragraph_second.list.items.second.items.first':
    '<bold>Toutes régions</bold> (de 00h00 à 23h59) : selon le calendrier de clôture publié en prenant en compte les jours fériés',
  'pages.advance.manage.table.header.unavailability': 'Type d’indisponibilité',
  'pages.advance.manage.table.header.start': 'Début',
  'pages.advance.manage.table.header.end': 'Fin',
  'pages.advance.manage.add.period_label': 'Période d’indisponibilité',
  'pages.advance.manage.add.region_label': 'Région',
  'pages.advance.period.region.metropole': 'Métropole',
  'pages.advance.period.region.antilles_guyane': 'Antilles - Guyane',
  'pages.advance.manage.add.button_label': 'Ajouter',
  'pages.advance.manage.info_box.title':
    'Attention aux jours entre la dernière gestion des acomptes et la période de paie',
  'pages.advance.manage.info_box.text': `<bold>L’indisponibilité dûe à la gestion de la paie doit prendre en compte le dernier jour de traitement des 
demandes d’acomptes jusqu’au dernier jour de traitement des paies.</bold>
<lineBreak/>Exemple, je veux définir la période d’indispo liée à la paie du mois de mars, réalisée sur le mois d’<bold>avril 2022 :</bold><lineBreak/>
<listContainer><listItem>dernier jour de traitement des acomptes avant la paie : lundi <bold>04/04/2022</bold></listItem>
<listItem>période de traitement des paies (selon calendrier de clôture) : du mardi <bold>05/04/2022</bold> au jeudi <bold>07/04/2022</bold></listItem>
<listItem>le service devra donc être indisponible aux intérimaires : du lundi <bold>04/04/2022</bold> à 00h00 au jeudi <bold>07/04/2022</bold> à 23h59</listItem>
</listContainer>`,
  'pages.advance.manage.delete.title':
    'Supprimer une période d’indisponibilité',
  'pages.advance.manage.delete.message':
    'Je souhaite supprimer la période d’indisponibilité du ',
  'pages.advance.manage.dropdown.edit': 'Modifier',
  'pages.advance.manage.dropdown.delete': 'Supprimer',
  'pages.advance.manage.add.success': 'Période ajoutée',
  'pages.advance.manage.add.error': 'Échec lors de l’ajout de la période',
  'pages.advance.manage.delete.success': 'Période supprimée',
  'pages.advance.manage.delete.error':
    'Échec lors de la suppression de la période',
  'pages.advance.manage.edit.success': 'Période modifiée',
  'pages.advance.period.pay_type': 'Due à la gestion des paies',
  'pages.advance.period.advance_treatment_type':
    'Due à la gestion des acomptes',
  'pages.advance.date.at': 'à',
  'pages.advance.date.range':
    '{{- startDate, DD/MM/YYYY à HH:mm }} au {{- endDate, DD/MM/YYYY à HH:mm }}',
  'pages.advance.list.table.column_headers.candidate': 'NOM Prénom',
  'pages.advance.list.table.column_headers.date': 'Date',
  'pages.advance.list.table.column_headers.source': 'Source',
  'pages.advance.list.table.source.ep': 'E.P.',
  'pages.advance.list.table.source.lucie': 'Lucie',
  'pages.advance.list.table.column_headers.advance_requested':
    'Acompte demandé',
  'pages.advance.list.table.agency_assigned':
    'Agence de rattachement de l’intérimaire',
  'pages.advance.list.table.column.advance_requested_transfer':
    '{{amount}} € <lightText>(par virement bancaire)</lightText>',
  'pages.advance.list.table.column.advance_requested_cheque':
    '{{amount}} € <lightText>(par chèque)</lightText>',
  'pages.advance.list.table.column_headers.preco_amount': 'Préconisé',
  'pages.advance.list.table.column_headers.granted_amount': 'Accordé',
  'pages.advance.list.table.column_headers.status': 'Statut',
  'pages.advance.list.table.grantedAmount': '{{count}} €',
  'pages.advance.list.status.validated': 'Acceptée',
  'pages.advance.list.status.auto-validated': 'Acceptée automatiquement',
  'pages.advance.list.status.auto-refused': 'Refusée automatiquement',
  'pages.advance.list.status.refused': 'Refusée',
  'pages.advance.list.status.canceled': 'Annulée',
  'pages.advance.list.status.ready-to-sent': 'En attente',
  'pages.advance.list.preco_amount_max': '(max. {{amount}})',
  'pages.advance.list.scud_user.default_name': 'Système (automatique)',
  'pages.advance.list.treated_by':
    'le {{- date, DD/MM/YYYY }} à {{- date, HH:mm}} par {{- author}}',
  'pages.advance.list.treated_by_auto':
    'le {{- date, DD/MM/YYYY }} à {{- date, HH:mm}} (automatique)',
  'pages.advance.list.bank_transfer': 'Paiement par virement bancaire',
  'pages.advance.error.validation.advance_period':
    'Une période d’indisponibilité existe déjà pour la période sélectionnée',
  'pages.advance.granted_amount.contract_detail':
    '<b>{{code}}</b> {{- agencyLabel}} / <b>{{matricule}}</b>',
  'pages.advance.unknownRelatedMonth': 'Mois inconnu',
  'pages.advance.list.table.column_headers.payment_method': 'Mode de paiement',
  'pages.advance.list.table.payment_method.bank_transfer': 'Virement bancaire',
  'pages.advance.list.table.payment_method.cheque': 'Chèque',
  'pages.advance.list.dropdown.refuse': 'Refuser la demande',
  'pages.advance.list.dropdown.refresh_preco':
    'Rafraîchir le montant préconisé',
  'pages.advance.list.dropdown.copy': 'Copier matricule Anaël : {{matricule}}',
  'pages.advance.list.dropdown.copied': 'Matricule copié',
  'pages.advance.list.refuse.title': 'Confirmer le refus de la demande',
  'pages.advance.list.refuse.message':
    'Après cette confirmation, la demande de <bold>{{- candidate}}</bold> sera refusée.',
  'pages.advance.list.validate.title': 'Confirmer la validation de la demande',
  'pages.advance.list.validate.message.part_1':
    'Après cette confirmation, la demande de <bold>{{- candidate}}</bold> sera validée et envoyée vers Anaël.  Aucun retour en arrière ne sera possible.',
  'pages.advance.list.validate.message.part_2':
    'Êtes-vous sûr de vouloir valider cette demande ?',
  'pages.advance.list.refuse.input_label':
    'Pour confirmer, laisser une note pour la ou les agences concernées *',
  'pages.advance.list.refuse.input_counter': '{{count}} / 50 caractères',
  'pages.advance.list.validate.success': 'Demande validée',
  'pages.advance.list.validate.error':
    'Échec lors de la validation de la demande',
  'pages.advance.list.refuse.success': 'Demande refusée',
  'pages.advance.list.refuse.error': 'Échec lors du refus de la demande',
  'pages.advance.list.refresh_preco.success': 'Montant préconisé mis à jour',
  'pages.advance.list.refresh_preco.error':
    'Échec lors de la mise à jour du montant préconisé',
  'pages.advance.table.empty': 'Aucune donnée à afficher',
  'pages.advance.table.loading': 'Chargement',
  'pages.advance.list.amount_error': 'Le montant est supérieur au préconisé',
  'pages.advance.list.amount_min_error': 'Le montant est inférieur à 2 €',
  'pages.advance.list.preco_error': 'Le montant préconisé a diminué',
  'pages.advance.list.preco_error_hint': 'Veuillez modifier le montant accordé',
  'pages.advance.list.max_preco_error_hint':
    'Le montant accordé est supérieur au préconisé total',
  'pages.advance.list.validate.preco_error':
    'Échec lors de la vérification des montants préconisés',
  'pages.advance.history.table.column_headers.payment_method': 'Paiement',
  'pages.advance.history.table.advance_status.sent': 'Envoyé vers Anaël',
  'pages.advance.history.table.advance_status.sending':
    'Envoi vers Anaël en cours...',
  'pages.advance.history.table.advance_status.failed':
    'Échec de l’envoi vers Anaël',
  'pages.advance.history.table.advance_status.ignored': 'Ignoré',
  'pages.advance.history.table.advance_status.saved_on_anael':
    'Enregistré dans Anael',
  'pages.advance.history.table.advance_status.pushed_to_bank':
    'Transmis à la trésorerie',
  'pages.advance.history.table.advance_status.refresh.success':
    'Envoyé vers Anaël',
  'pages.advance.history.table.advance_status.refresh.error':
    'Échec lors du l’envoi',
  'pages.advance.list.toast.preco_error':
    'Un ou plusieurs montants préconisés ont diminué.<lineBreak />Veuillez ajuster vos montants accordés',
  'advance_period.period_type.not_allowed':
    'La période paie est de 12 jours max',
  'pages.advance.list.tooltip.forced_advance_request':
    'Demande hors montant préconisé, validée par le RA',
  'pages.advance.list.tooltip.detailed_preco_amount':
    'Données issues d’Anaël :',
  'pages.advance.list.filters.results.loading': 'Chargement...',
  'pages.advance.list.filters.results.none': 'Pas de résultat',
  'pages.advance.list.filters.labels.agency': 'Filtrer par agence',
  'pages.advance.list.filters.hints.agency': 'Recherche par nom ou code agence',
  'pages.advance.history.filters.values.range':
    '{{- from, DD/MM/YYYY }} au {{- to, DD/MM/YYYY }}',
  'pages.advance.history.filters.labels.agency': 'Rechercher une agence',
  'pages.advance.history.filters.labels.status.0': 'Envoi en cours',
  'pages.advance.history.filters.labels.status.1': 'Acceptée',
  'pages.advance.history.filters.labels.status.2': 'Refusée',
  'pages.advance.history.filters.labels.status.3': 'Annulée',
  'pages.advance.history.filters.labels.status.4': 'Acceptée automatiquement',
  'pages.advance.history.filters.labels.status.5': 'Refusée automatiquement',
  'pages.advance.history.filters.labels.status.6': 'En attente',
  'pages.advance.history.filters.labels.status': 'Statut des demandes',
  'pages.advance.history.filters.labels.scopes': 'Périmètre',
  'pages.advance.history.filters.labels.scopes.managementCenter':
    'Toutes les demandes de mon centre de gestion',
  'pages.advance.history.filters.labels.scopes.superAdmin':
    'Toutes les demandes',
  'pages.advance.history.filters.labels.candidate': 'Rechercher un intérimaire',
  'pages.advance.history.filters.labels.creation_period':
    'Demande créée sur la période',
  'pages.advance.history.filters.labels.treatment_period':
    'Demande traitée sur la période',
  'pages.advance.history.filters.buttons.search': 'Rechercher',
  'pages.advance.unavailability.title':
    'Le service est temporairement indisponible',
  'pages.advance.unavailability.content':
    'Nos équipes sont en train de résoudre le problème. Désolé pour la gêne occasionnée.',
  'pages.imports.title': 'Liste des imports à traiter',
  'pages.import.title': "Détail d'un import",
  'pages.import-create.title': "Importer des relevés d'heures",
  'pages.import.index.button.import-create': "Importer des relevés d'heures",
  'pages.import-create.left-panel.title': "Importez vos relevés d'heures",
  'pages.import-create.left-panel.text':
    'Renseignez les informations de votre relevé d’heures, afin qu’il soit importé, validez la qualité de l’import et envoyez directement vos relevés d’heures sur Anaël.',
  'pages.import.show.datatable.title': 'Liste des relevés d’heures importés',
  'pages.import.show.datatable.footbar.offtool': 'Traiter hors outil',
  'pages.import.show.datatable.footbar.later': 'Reprendre plus tard',
  'pages.import.show.datatable.footbar.send_to_anael': 'Intégrer dans Anaël',
  'pages.import.show.datatable.actions.select_all':
    'Sélectionner tous les RH à traiter',
  'pages.import.show.datatable.actions.selectedTimesheets_one':
    '{{count}} RH sélectionné',
  'pages.import.show.datatable.actions.selectedTimesheets_other':
    '{{count}} RH sélectionnés',
  'pages.import.show.datatable.actions.toVerify': '{{count}} à vérifier',
  'pages.import.show.modal.sendToAnael.message':
    'Je souhaite <bold>intégrer dans Anaël {{nb}} relevés d’heures sélectionnés</bold> de mon import du <bold>{{date}} hors outil.</bold>',
  'pages.import.show.modal.sendToAnael.block.hasToVerify':
    "Un fichier sélectionné a le statut 'à vérifier'. Ce fichier ne sera pas intégré avec les autres et nécessite une vérification.",
  'pages.import.show.modal.offtool.message':
    'Je souhaite traiter les <bold>{{nb}} relevés d’heures sélectionnés</bold> de mon import du <bold>{{date}} hors outil.</bold>',
  'pages.import.show.modal.complete.title': 'Félicitations !',
  'pages.import.show.modal.complete.message':
    'Tous les relevés d’heure de l’import <bold> {{title}} </bold> ont bien été intégrés dans Anael ou traités hors outils.',
  'pages.import.show.modal.anael.title': 'Intégrer dans Anaël',
  'pages.import.show.modal.newFile': 'Importer un nouveau fichier',
  'pages.import.show.modal.returnToList': 'Retourner à la liste des imports',
  'pages.import.show.batch_anael.in_progress':
    'Import des relevés d’heures en cours',
  'pages.import.show.batch_anael.finish': 'Import des relevés d’heures terminé',
  'pages.import.show.batch_anael.in_progress_notification':
    'Intégration des relevés d’heures à Anael en cours',
  'pages.import.show.batch_anael.success_notification':
    'Les relevés d’heures ont été importés avec succès',
  'pages.import.show.batch_anael.confirmation':
    "Vous êtes sur le point d'intégrer à Anaël <blueText>{{-count}}/{{-total}}</blueText> relevés d'heures du <b>{{-date}}</b>",
  'pages.import.show.batch_anael.fail_notification':
    '{{-count }} relevés d’heures n’ont pas été importés et devront être revus et validés manuellement',
  'pages.import.show.toast.go-back':
    'Vous pourrez reprendre votre import plus tard',
  'pages.import-create.step1.file-importer.label': 'Fichier à importer',
  'pages.import-create.step1.file-importer.accept-text': 'CSV',
  'pages.import-create.step1.file-importer.title-add-btn': 'Choisir un fichier',
  'pages.import-create.step1.file-importer.helper-text': 'Obligatoire',
  'pages.import-create.step1.file-importer.download-example':
    'Télécharger un fichier exemple',
  'pages.import-create.step1.file-importer.error.no-example-found':
    'Aucun import exemple trouvé pour cette agence et ce client. Veuillez effectuer au moins un import complet avant de télécharger un exemple.',
  'pages.import-mapper.title': 'Import RH CSV',
  'pages.import-mapper.confirm_list': 'Liste des RHs à créer',
  'pages.import-mapper.cancel': 'Annuler',
  'pages.import-mapper.generate': 'Générer',
  'pages.import-mapper.next': 'Suivant',
  'pages.import-mapper.errors': '{{count}} erreur',
  'pages.import-mapper.errors_plural': '{{count}} erreurs',
  'pages.import-mapper.no_errors': 'Aucune erreur',
  'pages.import-mapper.previous_error': 'Erreur précédente',
  'pages.import-mapper.next_error': 'Erreur suivante',
  'pages.import-mapper.validation.lastname':
    'Le nom doit contenir uniquement des lettres',
  'pages.import-mapper.validation.firstname':
    'Le prénom doit contenir uniquement des lettres',
  'pages.import-mapper.validation.fullname':
    'Nom complet invalide (trop de parties, impossible de distinguer nom et prénom)',
  'pages.import-mapper.validation.date': 'Format de date invalide',
  'pages.import-mapper.validation.category': 'La rubrique doit être un nombre',
  'pages.import-mapper.validation.week':
    'Le numéro de semaine doit être un nombre entre 1 et 53',
  'pages.import-mapper.validation.contract':
    'Le numéro de contrat doit être un nombre',
  'pages.import-mapper.validation.logic_code':
    'Le code logique ne doit pas dépasser 6 caractères',
  'pages.import-mapper.validation.specific_designation':
    'La désignation spécifique ne doit pas dépasser 40 caractères',
  'pages.import-mapper.validation.incomplete_date_range':
    'Date de début et Date de fin doivent être mappées ensemble',
  'pages.import-mapper.validation.required_fields':
    'Pour continuer, vous devez mapper : (Nom + Prénom) OU Nom complet, (Date OU N° Semaine OU Date début + Date fin), et au moins une Rubrique',
  'pages.import-mapper.validation.has_errors':
    'Veuillez corriger toutes les erreurs de validation avant de continuer',
  'pages.import-mapper.validation.has_errors_warning':
    "Attention : Il y a des erreurs de validation. Les lignes avec erreurs seront ignorées lors de l'import.",
  'pages.import-mapper.missing_fields': 'Champs manquants',
  'pages.import-mapper.required_fields': 'Champs obligatoires',
  'pages.import-mapper.validation.missing_name':
    'Nom (Nom + Prénom ou Nom complet)',
  'pages.import-mapper.validation.missing_date':
    'Date (Date, N° Semaine ou Date début + Date fin)',
  'pages.import-mapper.validation.missing_category': 'Au moins une Rubrique',
  'pages.import-mapper.error.missing_data':
    "Données manquantes. Veuillez recommencer l'import depuis le début.",
  'pages.import-mapper.error.mismatched_params':
    "Les paramètres ne correspondent pas aux données stockées. Veuillez recommencer l'import.",
  'pages.import-mapper.error.load_failed':
    "Erreur lors du chargement des données. Veuillez recommencer l'import.",
  'pages.import-mapper.error.generic':
    "Une erreur est survenue. Veuillez recommencer l'import.",
  'pages.import-mapper.error.file_too_large':
    'Le fichier est trop volumineux (max 2 Mo). Veuillez réduire la taille du fichier ou le découper en plusieurs imports.',
  'pages.import-mapper.error.too_many_rows':
    'Le fichier contient trop de lignes (max 500). Veuillez découper votre fichier en plusieurs imports.',
  'pages.import-mapper.error.redirect_message':
    "Vous allez être redirigé vers la page de création d'import.",
  'pages.import-mapper.back_to_create': "Retour à la création d'import",
  'pages.import-mapper.upload_file_title': 'Importer un fichier',
  'pages.import-mapper.upload_file_description':
    'Le fichier a été perdu suite à un rechargement de page. Veuillez réimporter votre fichier CSV.',
  'pages.import-create.step2.title': 'Votre fichier est en cours de traitement',
  'pages.import-create.step2.subtitle':
    'Merci de patienter quelques instants...',
  'pages.import-create.step2.label':
    'Une fois votre fichier importé, vous pourrez',
  'pages.import-create.step2.confirmText':
    '<bold>Confirmer l’import</bold> et commencer le traitement de vos RH',
  'pages.import-create.step2.cancelText':
    '<bold>Annuler l’import</bold>, le supprimera de la base de données.',
  'pages.import-create.step2.btnConfirmImport': 'Confirmer l’import',
  'pages.import-create.imported.title': 'Votre fichier est prêt',
  'pages.import-create.imported.subtitle':
    'Merci pour votre patience, votre fichier a été importé avec succès !',
  'pages.import-create.imported_with_failure.title': 'Un problème est survenu',
  'pages.import-create.imported_with_failure.subtitle':
    "Un problème est survenu lors du chargement du fichier, rendant l'import impossible. Merci de vérifier le fichier et de réessayer",
  'pages.import-create.no-example-found':
    'Aucun import exemple trouvé pour cette agence et ce client. Veuillez effectuer au moins un import complet avant de télécharger un exemple.',
  'pages.super-admin.title': 'Super Admin',
  'pages.referentials.title': 'Référentiels clients',
  'pages.referentials.breadcrumb': 'Rubriques de {{- clientLabel}}',
  'pages.referentials.tabs.active': 'Liste des rubriques',
  'pages.referentials.tabs.archived': 'Liste des rubriques archivées',
  'pages.referentials.tabs.settings': 'Paramètres',
  'pages.referentials.searchPlaceholder': 'Rechercher une rubrique...',
  'pages.referentials.settingsRefTitle': 'Paramètres du référentiel client',
  'pages.referentials.showLogicCode': 'Affichage du code logique',
  'pages.referentials.showLogicCodeDescription':
    "Activer ou désactiver l'affichage du code logique et de la désignation spécifique dans les détails RH pour ce client",
  'pages.referentials.settingsRefSubtitle':
    'Configurez les options spécifiques pour ce client',
  'pages.referentials.settings.logicCodeDesignationLabel':
    'Code logique et désignation spécifique',
  'pages.referentials.settings.updateSuccess':
    'Les paramètres ont été mis à jour',
  'pages.referentials.associated': 'Rubriques associées',
  'pages.referentials.notAssociated': 'Rubriques non associées',
  'pages.referentials.categoryTotal_one': '\u00A0| {{count}} rubrique',
  'pages.referentials.categoryTotal_other': '\u00A0| {{count}} rubriques',
  'pages.referentials.header.clientCategory': 'Rubrique client',
  'pages.referentials.header.platformCategoryCode': 'Code rubrique',
  'pages.referentials.header.anaelCategory': 'Rubrique Anaël',
  'pages.referentials.header.usage': 'Utilisation',
  'pages.referentials.header.actions': 'Actions',
  'pages.referentials.usageWithLast_one':
    '{{count}} utilisation, dernière le {{- date}}',
  'pages.referentials.usageWithLast_other':
    '{{count}} utilisations, dernière le {{- date}}',
  'pages.referentials.selectCategory': 'Sélectionnez une rubrique',
  'pages.referentials.actions.activate': 'Activer la rubrique',
  'pages.referentials.actions.archive': 'Archiver la rubrique',
  'pages.referentials.emptyCategoryToAssociate':
    "Vous n'avez plus de rubrique à associer.",
  'pages.referentials.columns.client': 'Client',
  'pages.referentials.columns.associatedCategories': 'Rubriques associées',
  'pages.referentials.columns.unassociatedCategories':
    'Rubriques non associées',
  'pages.referentials.columns.associationRate': 'Taux associations',
  'pages.referentials.columns.actions': 'Actions',
  'pages.referentials.clients_one': '{{count}} client',
  'pages.referentials.clients_other': '{{count}} clients',
  'pages.referentials.noData': 'Aucun référentiel trouvé',
  'pages.referentials.unassociatedWarning_one':
    "{{count}} rubrique n'a pas de correspondance",
  'pages.referentials.unassociatedWarning_other':
    "{{count}} rubriques n'ont pas de correspondance",
  'pages.referentials.allAssociatedSuccess':
    '100% des rubriques sont associées',
  'pages.referentials.associationSuccess':
    "L'association a bien été prise en compte",
  'pages.referential-details.title': 'Référentiel',
  'pages.referential.archivedTitle': 'Archivage des rubriques',
  'pages.referential.archivedSubtitle':
    "Les rubriques archivées ne s'affichent plus dans les RH",
  'pages.referentials.agency': 'Agence',
  'pages.referentials.returnToTimesheet': 'Retour au RH',
  'pages.referentials.comeBackToRH': 'Vous reviendrez sur le RH en cours',
  'pages.monitoring.title': 'Suivi des imports',
};

const profile = {
  'profile_menu.link.needHelp': 'Besoin d’aide ?',
  'profile_menu.link.revertImpersonate': 'Retour sur mon compte',
  'profile_menu.link.logout': 'Déconnexion',
  'profile_menu.link.delegations': 'Gestion des délégations',
  'profile_menu.link.admin_users': 'Gestion des périmètres',
  'profile_menu.link.missing_agencies': 'Agences manquantes',
  'profile_menu.profile_details.group': 'Périmètre',
  'profile_menu.impersonate.message':
    'Vous êtes connecté avec le compte de {{profileName}}',
};

const anaelCategory = {
  'anaelCategory.title': 'Rubriques',
  'anaelCategory.attached': 'Rubrique rattachée',
  'anaelCategory.search.placeholder': 'Numéro de rubrique ou nom',
  'anaelCategory.slipWithSameCategory':
    'La catégorie "{{- code }}" est déjà associée à une autre ligne. Elle sera automatiquement détachée de celle-ci pour être rattachée à la nouvelle.',
  'anaelCategory.suggestions_one':
    'Suggestion en provenance du contrat ({{ count }})',
  'anaelCategory.suggestions_other':
    'Suggestions en provenance du contrat ({{ count }})',
  'anaelCategory.anaelCategoryWithCode': 'Rubrique {{ code }}',
  'anaelCategory.noChosenAnaelCategory': 'Aucune rubrique trouvée',
  'anaelCategory.pleaseSearchToFindAnaelCategory':
    'Veuillez faire une recherche afin de trouver une rubrique',
  'anaelCategory.detachWarning':
    'En cliquant sur détacher, elle ne sera plus associée au financier. Êtes-vous sûr de vouloir détacher la rubrique ?',
};

const actions = {
  'action.save.confirm': 'Enregistrement terminé',
  'action.delete.confirm': 'Suppression terminée',
  'action.delete.title': 'Confirmer la suppression ?',
  'action.delete.message': 'Cette action est irréversible',
  'action.edit.label': 'Modifier',
  'action.delete.label': 'Supprimer',
  'action.reinit.label': 'Réinitialiser',
  'action.submit.label': 'Valider',
  'action.confirm.label': 'Confirmer',
  'action.cancel.label': 'Annuler',
  'action.refuse.label': 'Refuser',
  'action.next.label': 'Suivant',
  'action.prev.label': 'Précédent',
  'action.return.label': 'Retour',
  'action.continue.label': 'Continuer',
  'action.detachContract': 'Détacher le contrat',
  'action.confirmDetach': 'Oui, je détache',
  'action.attachContract': 'Rattacher le contrat',
  'action.changeAnaelCategory': 'Changer la rubrique',
  'action.detachAnaelCategory': 'Détacher la rubrique',
  'action.close.label': 'Fermer',
  'action.finish.label': 'Terminer',
  'action.apply': 'Appliquer',
};

const common = {
  'common.no': 'Non',
  'common.warning': 'Attention !',
  'common.action': 'Action',
  'common.actions': 'Actions',
  'common.props.agency': 'Agence',
  'common.props.client': 'Client',
  'common.props.contracts': 'contrats',
  'common.props.createdAt': 'Date de création',
  'common.props.updatedAt': 'Date de modification',
  'common.props.showDetails': 'Voir les détails',
  'common.props.lastUpdatedAt':
    'Dernière mise à jour le {{- date, DD/MM/YYYY }} à {{ date, HH[h]mm }}',
  'common.novelty': 'Nouveauté',
  'common.search': 'Recherche',
  'common.searching': 'Recherche...',
  'common.noOptions': 'Aucun résultat',
  'common.loading': 'Chargement en cours ...',
  'common.results_one': 'Résultat de la recherche ({{ count }})',
  'common.results_other': 'Résultats de la recherche ({{ count }})',
  'common.suggestions_one': "Suggestion de l'import ({{ count }})",
  'common.suggestions_other': "Suggestions de l'import ({{ count }})",
  'common.dates':
    'Du {{- startDate, DD/MM/YYYY }} au {{- endDate, DD/MM/YYYY }}',
  'common.emptyText': 'Aucune donnée à afficher',
  'common.sort': 'Trier',
  'common.sortBy': 'Trier par',
  'common.order': 'Ordre',
  'common.asc': 'Croissant',
  'common.desc': 'Décroissant',
  'common.createdAt': 'Créé le',
  'common.otherFilters_other': '{{ count }} autres filtres',
  'common.otherFilters_one': '{{ count }} autre filtre',
  'common.filterList': 'Liste des filtres',
  'common.missing': 'Manquant',
  'common.unselectAll': 'Désélectionner tout',
  'common.groups': '{{value}} groupes',
};

const forms = {
  'form.validation.common_error': 'Une erreur est survenue',
  'form.validation.too_long': '{{number}} caractères max.',
  'form.validation.too_short': '{{number}} caractères min.',
  'form.validation.required': 'Champ obligatoire',
  'form.validation.short_required': 'Obligatoire',
  'form.validation.float': 'Le champ doit être un nombre à virgule flottante.',
  'form.select.loading': 'Chargement...',
  'form.select.no_result': ' Pas de résultat',
  'form.select.tape_to_search':
    'Saisissez {{number}} caractères pour lancer la rechercher',
  'form.select.date.range':
    'du {{- from, DD/MM/YYYY }} au {{- to, DD/MM/YYYY }}',
  'form.financial.add': 'Ajouter une ligne',
  'form.financial.paid': 'Payé',
  'form.financial.billed': 'Facturé',
  'form.financial.coef': 'Coefficient',
  'form.financial.base': 'Base',
  'form.financial.rate': 'Taux',
  'form.financial.totalPaid': 'Total payé',
  'form.financial.totalBilled': 'Total Facturé',
  'form.financial.categories': 'Rubrique',
  'form.financial.add_row': 'Ajouter la ligne',
  'form.financial.week': 'Semaine',
  'form.financial.confirmation': 'Une nouvelle ligne a bien été ajoutée.',
  'form.validation.financial.logicCode':
    "Anaël n'autorise que 6 caractères. Les codes plus longs sont en cours de développement.",
};

const system = {
  'system.title': 'Nina',
  'system.actions.save': 'Enregistrer',
  'system.actions.download': 'Télécharger',
  'system.actions.cancel': 'Annuler',
  'system.actions.confirm': 'Confirmer',
  'system.actions.start': 'Commencer',
  'system.actions.retry': 'Réessayer',
  'system.actions.modify': 'Modifier',
  'system.roles.nina.super_user': 'Super admin',
  'system.roles.nina.responsable_cg': 'Responsable CG',
  'system.roles.nina.assistant_cg': 'Assistant(e) CG',
  'system.roles.nina.agence': 'Agence',
};

const api = {
  'api.advance_requests.service_unavailable.advance_requests.read':
    'Impossible d’accéder aux demandes d’acompte pour le moment',
  'api.advance_requests.service_unavailable.advance_requests.write':
    'Impossible de traiter les demandes d’acompte pour le moment',
  'api.advance_requests.service_unavailable.anael.read':
    'Impossible d’interroger anael pour le moment',
  'api.advance_requests.service_unavailable.anael.write':
    'Impossible d’envoyer des informations à anael pour le moment',
  'api.timesheets.service_unavailable.anael':
    'Nous sommes désolés, une erreur est survenue, vous pouvez rafraîchir la page pour réessayer dans un petit moment.',
};

const modal = {
  'modal.logout.error': 'Une erreur est survenue lors de la déconnexion',
  'modal.logout.success': 'Déconnexion avec succès',
};

const superAdmin = {
  'superAdmin.title': 'Super Admin',
  'superAdmin.launchMatchingContract.btn': 'Relancer le matching contrat',
  'superAdmin.launchMatchingContract.success.toast':
    'La relance des matchings contrat a fonctionné',
  'superAdmin.launchMatchingContract.error.toast':
    "La relance des matchings contrat n'a pas fonctionné",
};

const importMapper = {
  'importMapper.type.ignore': '',
  'importMapper.type.lastname': 'Nom',
  'importMapper.type.firstname': 'Prénom',
  'importMapper.type.fullname': 'Nom complet',
  'importMapper.type.date': 'Date',
  'importMapper.type.start_date': 'Date de début',
  'importMapper.type.end_date': 'Date de fin',
  'importMapper.type.category': 'Rubrique',
  'importMapper.type.week': 'N° semaine',
  'importMapper.type.contract': 'N° contrat',
  'importMapper.type.logic_code': 'Code logique',
  'importMapper.type.specific_designation': 'Désignation spécifique',
  'importMapper.name.lastname_firstname': 'NOM Prénom',
  'importMapper.name.firstname_lastname': 'Prénom NOM',
  'importMapper.date.DD-MM-YYYY': 'jour-mois-année',
  'importMapper.date.YYYY-MM-DD': 'année-mois-jour',
  'importMapper.date.MM/DD/YYYY': 'mois/jour/année',
  'importMapper.date.DD/MM/YYYY': 'jour/mois/année',
  'importMapper.date.YYYY/MM/DD': 'année/mois/jour',
  'importMapper.role.base': 'Base',
  'importMapper.role.rate_paid': 'Taux payé',
  'importMapper.role.total_paid': 'Total payé',
  'importMapper.role.rate_billed': 'Taux facturé',
  'importMapper.role.total_billed': 'Total facturé',
};

const adminUsers = {
  'pages.admin-users.title': 'Gestion des périmètres',
  'pages.admin-user-show.title': 'Fiche utilisateur',
  'admin_users.title': 'Gestion des périmètres',
  'admin_users.search.placeholder': 'Rechercher un utilisateur...',
  'admin_users.table.lastname': 'Nom',
  'admin_users.table.firstname': 'Prénom',
  'admin_users.table.email': 'Email',
  'admin_users.table.job': 'Poste',
  'admin_users.table.analytic_code': 'Code analytique',
  'admin_users.table.analytic_label': 'Libellé analytique',
  'admin_users.empty': 'Aucun utilisateur trouvé',
  'admin_users.show.profile': 'Profil',
  'admin_users.show.roles': 'Rôles',
  'admin_users.show.scopes': 'Périmètres',
  'admin_users.show.email': 'Email',
  'admin_users.show.job': 'Poste',
  'admin_users.show.analytic_code': 'Code analytique paie',
  'admin_users.show.analytic_label': 'Libellé analytique',
  'admin_users.show.bu': 'BU principale',
  'admin_users.show.title': 'Permissions de {{name}}',
  'admin_users.show.scud_unavailable':
    'Impossible de charger le profil SCUD pour cet utilisateur.',
  'admin_users.roles.name': 'Nom',
  'admin_users.roles.application': 'Application',
  'admin_users.roles.add': 'Ajouter un rôle',
  'admin_users.roles.add.success': 'Rôle ajouté avec succès',
  'admin_users.roles.remove.title': 'Supprimer le rôle',
  'admin_users.roles.remove.message':
    'Voulez-vous vraiment supprimer ce rôle ?',
  'admin_users.roles.remove.success': 'Rôle supprimé avec succès',
  'admin_users.roles.select': 'Sélectionner un rôle',
  'admin_users.scopes.add': 'Ajouter un périmètre',
  'admin_users.scopes.add.success': 'Périmètre ajouté avec succès',
  'admin_users.scopes.add.unavailable':
    "Impossible d'ajouter un périmètre pour le moment. Veuillez réessayer plus tard.",
  'admin_users.scopes.remove.title': 'Supprimer le périmètre',
  'admin_users.scopes.remove.message':
    'Voulez-vous vraiment supprimer ce périmètre ?',
  'admin_users.scopes.remove.success': 'Périmètre supprimé avec succès',
  'admin_users.scopes.select_agency': 'Rechercher une agence / CG',
  'admin_users.scopes.analytic_code': 'Code analytique',
  'admin_users.scopes.agency_label': 'Agence opérationnelle',
  'admin_users.scopes.application': 'Périmètre',
  'admin_users.scopes.is_exception': 'Exception',
  'admin_users.scopes.comment': 'Commentaire (optionnel)',
};

const monitoring = {
  'monitoring.title': 'Suivi des imports',
  'monitoring.refresh': 'Actualiser',
  'monitoring.noData': 'Aucune donnée disponible',

  // Summary
  'monitoring.summary.generatedAt': 'Généré le {{- date}}',
  'monitoring.summary.totalChannels': 'Channels',
  'monitoring.summary.anomalies': 'Anomalies',
  'monitoring.summary.agenciesIssues': 'Agences en alerte',

  // Card
  'monitoring.card.confidence': 'confiance',
  'monitoring.card.imports': 'Imports',
  'monitoring.card.expected': 'attendus',
  'monitoring.card.gap': 'Écart depuis dernier import',
  'monitoring.card.lastImport': 'Dernier import',
  'monitoring.card.nextCron': 'Prochain cron',
  'monitoring.card.agenciesIssues': 'Agences en alerte',
  'monitoring.card.anomaly': 'Anomalie',

  // Agencies table
  'monitoring.agencies.title': 'Agences avec problèmes',
  'monitoring.agencies.channel': 'Channel',
  'monitoring.agencies.agencyCode': 'Code agence',
  'monitoring.agencies.agencyLabel': 'Libellé',
  'monitoring.agencies.confidence': 'Confiance',
  'monitoring.agencies.current': 'Actuel',
  'monitoring.agencies.expected': 'Attendu',
  'monitoring.agencies.hoursSilent': 'Heures sans import',
};

const missingAgencies = {
  'missing_agencies.title': 'Agences manquantes',
  'missing_agencies.empty': 'Aucune agence manquante à traiter',
  'missing_agencies.table.channel': 'Channel',
  'missing_agencies.table.agency_code': 'Code agence',
  'missing_agencies.table.first_seen': 'Première détection',
  'missing_agencies.table.last_seen': 'Dernière détection',
  'missing_agencies.table.occurrences': 'Occurrences',
  'missing_agencies.table.status': 'Statut',
  'missing_agencies.table.actions': 'Actions',
  'missing_agencies.status.to_qualify': 'À qualifier',
  'missing_agencies.status.false_positive': 'Faux positif',
  'missing_agencies.action.false_positive': 'Faux positif',
  'missing_agencies.action.cancel': 'Annuler',
  'missing_agencies.toast.false_positive_success':
    'Agence marquée comme faux positif',
  'missing_agencies.toast.cancel_success': 'Marquage faux positif annulé',
};

export default {
  ...navigation,
  ...pages,
  ...actions,
  ...common,
  ...forms,
  ...services,
  ...system,
  ...profile,
  ...anaelCategory,
  ...modal,
  ...api,
  ...superAdmin,
  ...importMapper,
  ...monitoring,
  ...adminUsers,
  ...missingAgencies,
};
